import UrlTypes from './url-types.js';

const { PARAMETER } = UrlTypes;

/**
 * URL-related utility functions.
 *
 * @class UrlUtils
 * @memberof Mojito.Core.Base
 */
export default {
    /**
     * Reads {@link Mojito.Core.Base.UrlTypes.PARAMETER.ADDITIONAL_CONTEXT|additionalContext} from a URL search string.
     *
     * @param {string} [urlSearchString = window.location.search] - URL search string.
     * @returns {string|undefined} Additional context from the URL, or undefined when absent.
     * @function Mojito.Core.Base.UrlUtils#getAdditionalContextFromUrl
     */
    getAdditionalContextFromUrl: (urlSearchString = window.location.search) => {
        const params = new URLSearchParams(urlSearchString);
        return params.get(PARAMETER.ADDITIONAL_CONTEXT) || undefined;
    },
};
